<template>

  <div class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
    <label for="month">Day & Time to End the Interval</label>
    <date-time-picker   id="month"
                        v-model="month"
                        :format="format"
                        :view-mode="viewMode"
                        :min-date="minDate"
                        :max-date="maxDate"
                        :timezone="timezone"
    ></date-time-picker>
  </div>

  <!-- Select Zones to report on -->
  <div    class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
    <label  for="zones[]">Select Zones to report on.</label>
    <select2    id="zones[]"
                :multiple="true"
                :can-select-all="true"
                :options="zones"
                v-model:value="_selectedZones"
                :allow-clear="true"
    ></select2>
  </div>

  <div class="flex justify-center">
    <button v-if="isRunning"
            class="col-span-2 w-full lg:w-2/3 my-4 relative inline-flex items-center justify-center
                            px-4 py-2 border border-transparent text-sm bg-blue-600 text-white font-medium py-2 px-4
                            rounded opacity-50 cursor-not-allowed">
      <span class="lnr icon-loading animate-spin mr-3"></span>
      Running Report, Please Wait
    </button>
    <button v-else-if="_selectedZones.length === 0"
            class="col-span-2 w-full lg:w-2/3 my-4 relative inline-flex items-center justify-center
                            px-4 py-2 border border-transparent text-sm bg-blue-600 text-white font-medium py-2 px-4
                            rounded opacity-50 cursor-not-allowed">
      Please Select At Least One Zone
    </button>
    <button v-else
            class="col-span-2 w-full lg:w-2/3 my-4 relative inline-flex items-center justify-center px-4 py-2 border
                            border-transparent text-sm leading-5 font-medium rounded-md text-white bg-blue-600
                            hover:bg-blue-500 focus:outline-none focus:ring-blue-200 focus:border-blue-700
                            active:bg-blue-700"
            @click="runReport">
      Run Report
    </button>
  </div>
</template>

<script>
import axios from "axios"
import {companyMixin} from '@/mixins/companyMixin'
import {permissionMixin} from '@/mixins/permissionMixin'
import {iconNamesMixin} from '@/mixins/IconNamesMixin';

import DateTimePicker from "../Reports/DateTimePicker";
import Select2 from "../elements/select2";

export default {
  name: "ZoneIntervalSelection",
  mixins: [companyMixin, permissionMixin, iconNamesMixin],
  components: {DateTimePicker, Select2},
  props: {
    zones: {
      type: Object,
      default: [],
    },
    interval: {
      type: String,
      default: '',
    },
    endOfInterval: {
      type: Date,
    },
    minDate: {
      type: Date,
    },
    maxDate: {
      type: Date,
    },
    selectedZones: {
      type: Array,
    },
    timezone: {
      type: String,
      default: 'America/New_York',
    },

  },
  data() {
    return {
      month: this.maxDate,
      isRunning: false,
      semiMonthIntervals: {
        first: '1st Half (1 - 15)',
        last: '2nd Half (16 - End of Month)',
      },

      format: _.indexOf(['monthly', 'semi-monthly'], this.intervalInput) > -1 ? 'MMMM YYYY' : 'MMMM DD, YYYY',
      viewMode: _.indexOf(['monthly', 'semi-monthly'], this.intervalInput) > -1  ? 'months' : 'days',


      _selectedZones: this.selectedZones,

      _semiMonthSection: new Date().getDate() <= 15 ? 'first' : 'last',
      _endOfInterval: new Date(),
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    runReport() {
      this.$emit('run-report')
    },
  },
  computed: {},
  watch: {
    selectedZones (val, old) {
      if (val !== old) {
        this.$data._selectedZones = val
      }
    },
    _selectedZones(val, old) {
      if (val !== old) {
        this.$emit('update:selectedZones', this.$data._selectedZones)
      }
    },
    // selectedZones: {
    //   handler(value, oldValue) {
    //     let allIndex = value.indexOf('all')
    //     if (allIndex !== -1) {
    //       let newSelectedZones = Object.keys(this.zones)
    //       let zonesAllIndex = newSelectedZones.indexOf("all")
    //       newSelectedZones.splice(zonesAllIndex, 1)
    //       this.selectedZones = newSelectedZones
    //     }
    //   }, deep: true
    // },
  },
}
</script>

<style scoped>

</style>